<template>
  <div class="contact-page">
    <div class="detail-banner">
      <div class="container">
        <h1>Contact Us</h1>
        <p class="pd-banner-sub">Share your brief. We'll architect your entry.</p>
      </div>
    </div>
    <!-- 复用首页「联系我们」模块的功能内容（真实联系方式 + 提交表单） -->
    <ContactsUs />
  </div>
</template>

<script>
import ContactsUs from '../components/ContactsUs.vue'

export default {
  name: 'Contact',
  components: {
    ContactsUs
  }
}
</script>

<style scoped>
/* 蓝白主题变量（roadlinkglobal 全局调色板，组件内自包含） */
.contact-page {
  --primary: #265fff;
  --primary-dark: #1a3a5f;
  --primary-light: #4dabf7;
  /* 用户要求：整页背景改为灰色 */
  background: #f0f2f5;
  min-height: 100vh;
}

.detail-banner {
  background: url(~@/assets/home_banner.jpg);
  background-size: cover;
  background-position: center;
  color: #fff;
  padding: 100px 0;
  text-align: center;
}
.detail-banner .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.detail-banner h1 {
  font-size: 40px;
  font-weight: 800;
  margin: 0;
  line-height: 1.2;
}
.detail-banner .pd-banner-sub {
  margin: 0 auto;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.6;
  max-width: 700px;
}
@media (max-width: 768px) {
  .detail-banner { padding: 48px 0; }
  .detail-banner h1 { font-size: 28px; }
  .detail-banner .pd-banner-sub { font-size: 14px; }
}
@media (max-width: 576px) {
  .detail-banner h1 { font-size: 24px; }
  .detail-banner .pd-banner-sub { font-size: 13px; }
}
</style>
